import axios from 'axios';
import store from '../store';
import router from '../router';
import { Message } from 'element-ui';
import { refreshTokenExir } from '@/common/js/util';
import baseRequest from '@/common/js/baseRequest';
import globalVar from '@/common/js/global';
import loading from '../common/js/load';
import baseUrl from '@/common/config';

// josn数据序列化
import qs from 'qs';
// token过期时效（超过时效后重新更新时间戳）
let expireTime = 10 * 60 * 1000;

axios.defaults.baseURL = baseUrl;

// 超时时间 20s
axios.defaults.timeout = expireTime; //李友根说先设置成60

// 拦截请求
axios.interceptors.request.use(
  (config) => {
    //loading.startLoading()
    // 每次请求加上token
    if (config.method === 'post' || config.method === 'put') {
      let sign = '?';
      if (config.url.indexOf('?') > 0) {
        sign = '&';
      }
      config.url += sign + 'lang=' + 'zh_CN';
    } else if (config.method === 'get' || config.method === 'delete') {
      config.params = {
        ...config.params,
        lang: 'zh_CN',
      };
    }
    // config.url = '.' +config.url //打包使用
    // config.url = 'richin/dev' +config.url //开发使用
    if (
      store.state.userInfo.userInfo.access_token &&
      !(
        config.url.indexOf('uaa/auth/code/image') > -1 ||
        config.url.indexOf('uaa/auth/form') > -1 ||
        config.url.indexOf('maindata/dict/getAllDictForMap') > -1
      )
    ) {
      if (config.method === 'post' || config.method === 'put') {
        //获取字典的不传token，如果传了会报错
        config.url += store.state.userInfo.userInfo.access_token
          ? '&access_token=' + store.state.userInfo.userInfo.access_token
          : '';
      } else if (config.method === 'get' || config.method === 'delete') {
        config.params = {
          ...config.params,
          access_token: store.state.userInfo.userInfo.access_token,
        };
      }

      // config.headers['Authorization'] = "Bearer " + store.state.userInfo.userInfo.access_token
    }
    // 汇率--公司汇率取当月第一天
    if (config.url.indexOf('/maindata/currencyExchange/getCurrencyExchange') != -1) {
      if (config.data.exchangeType == 'Cooperate') {
        config.data.exchangeDate = baseRequest.getBeginOfMonth(config.data.exchangeDate);
      }
    }
    return config;
  },
  (err) => {
    //loading.endLoading()
    return Promise.reject(err);
  }
);

// 统一处理返回结果
axios.interceptors.response.use(
  (response) => {
    //loading.endLoading()
    // token过期
    if (response.data.code === 2003) {
      store.commit('deleteUserInfo');
      router.push('/login');
    } else {
      // console.log(store.state.userInfo.userInfo.expir - new Date().getTime() - 1.9*60*60*1000)
      // token半小时过期更新  0.5为半小时
      if (
        globalVar.refreshTokenFlag == 0 &&
        store.state.userInfo.userInfo.expir &&
        store.state.userInfo.userInfo.expir - new Date().getTime() <= 0.5 * 60 * 60 * 1000
      ) {
        console.log(globalVar.refreshTokenFlag);
        globalVar.refreshTokenFlag = 1;
        refreshTokenExir();
      }
    }
    return Promise.resolve(response);
  },
  (err) => {
    loading.endLoading();
    if (err.code === 'ECONNABORTED' && err.message.indexOf('timeout') !== -1) {
      Message.error('网络超时');
    }
    if (err.message === 'Network Error') {
      Message.error('网络超时');
    }
    if (err.response.status === 401) {
      store.commit('deleteUserInfo');
      router.push('/login');
      const data = {
        code: -1,
        message: '登录已过期',
      };
      return Promise.reject(data);
    }
    return Promise.reject(err);
  }
);

// 重新封装axios方法
export default {
  post(url, params) {
    return url.indexOf('uaa/auth/form') === -1
      ? axios({
          method: 'post',
          url: `${url}`,
          data: params || {},
        })
      : axios({
          method: 'post',
          url: `${url}`,
          headers: { deviceId: sessionStorage.deviceId },
          data: qs.stringify(params) || {},
        });
  },
  get(url, params) {
    const tempParams = {
      ...(params || {}),
      // 解决IE缓存添加一个随机时间戳
      _timer: +new Date(),
    };
    return axios({
      method: 'get',
      params: tempParams,
      url: `${url}`,
    });
  },
  put(url, params, data) {
    return axios({
      method: 'put',
      url: `${url}`,
      params: params || {},
      data: data,
    });
  },
  delete(url, params, data) {
    return axios({
      method: 'delete',
      url: `${url}`,
      params: params || {},
      data: data,
    });
  },
};
